import { Request } from "../Utils/useHttps";

const createOurProjectModuleApis = (base) => ({
  getOurProjects: (id) => Request.get(`${base}/`, { params: { id } }),
  getAllProjectCategories: () => Request.get(`${base}/categories`),
  addProject: (data) =>
    Request.post(`${base}/`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateProject: (id, data) =>
    Request.put(`${base}/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteProject: (id) => Request.delete(`${base}/${id}`),
  getProjectById: (id) => Request.get(`${base}/`, { params: { id } }),
  addProjectToHomeScreen: (data) =>
    Request.post(`${base}/change-home-screen-status`, data),
  getSimilarProjectExpectAdded: (id) =>
    Request.get(`${base}/similar-expect-added/`, { params: { id } }),
  postSimilarProject: (data) => Request.post(`${base}/similar-projects/`, data),
  deleteSimilarProject: (id) =>
    Request.delete(`${base}/similar-projects/`, { params: { id } }),
  updateSimilarProjectPosition: (id, position) =>
    Request.put(`${base}/similar-projects/update-position`, { id, position }),
  getAddedSimilarProject: (id) =>
    Request.get(`${base}/similar-projects/`, { params: { id } }),
  getParentProjectCategories: () => Request.get(`${base}/fetch-parent-category`),
  addSubCategory: (data) =>
    Request.post(`${base}/add-sub-category`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateSubCategory: (data) =>
    Request.put(`${base}/update-sub-category`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getSubCategories: (params) =>
    Request.get(`${base}/get-sub-categories`, { params }),
  getOnTheBasisOfSubCategory: (id, params) =>
    id
      ? Request.get(`${base}/by-sub-category-id/${id}`, { params })
      : Request.get(`${base}/manage-projects`, { params }),
  toggleProjectStatus: (id) => Request.put(`${base}/toggle-status/${id}`),
  updateSubCategoryPosition: (id, position) =>
    Request.put(`${base}/update-category-position`, { id, position }),
  updateProjectPosition: (data) => Request.put(`${base}/update-position`, data),
});

export const commercialDesignProjectApis = createOurProjectModuleApis(
  "our-project-commercial-design",
);
export const corporateDesignProjectApis = createOurProjectModuleApis(
  "our-project-corporate-design",
);

const createInteriorDesignModuleApis = (base) => ({
  createInteriorDesign: (data) =>
    Request.post(`${base}/`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getInteriorDesign: (offset = 0, limit = 10, params = {}) => {
    const queryParams = { offset, limit, ...params };
    return Request.get(base, { params: queryParams });
  },
  getInteriorDesignById: (id) =>
    Request.get(`${base}/get-single-${base}/${id}`),
  updateInteriorDesign: (id, data) =>
    Request.put(`${base}/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteInteriorDesign: (id) => Request.delete(`${base}/${id}`),
  addPopularInteriorDesign: (data) =>
    Request.post(`/${base}/add-popular-${base}`, data),
  getAllInteriorDesigns: () => Request.get(`/${base}/on-home-screen`),
  getAllInteriorDesignNamesForPopularDesign: () =>
    Request.get(`/${base}/all-names`),
  addInteriorDesignToHomeScreen: (data) =>
    Request.post(`/${base}/change-home-screen-status`, data),
  getSimilarInteriorDesign: (id) =>
    Request.get(`/${base}/similar-design/${id}`),
  addSimilarInteriorDesign: (data) => Request.post(`/${base}/similar`, data),
  removeSimilarInteriorDesign: (id) =>
    Request.delete(`/${base}/similar/${id}`),
  updateSimilarInteriorDesignPosition: (id, position) =>
    Request.put(`/${base}/similar/update-position`, { id, position }),
  getSimilarInteriorDesignExpectSelected: (id) =>
    Request.get(`/${base}/expect/${id}`),
  updateInteriorDesignPosition: (data) =>
    Request.put(`${base}/update-position`, data),
});

const commercialInteriorDesignModuleApis = createInteriorDesignModuleApis(
  "commercial-interior-design",
);
const corporateInteriorDesignModuleApis = createInteriorDesignModuleApis(
  "corporate-interior-design",
);

const createArchitectureDesignModuleApis = (base) => ({
  addArchitectureDesign: (data) =>
    Request.post(`/${base}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getArchitectureDesign: (offset = 0, limit = 10, params) =>
    Request.get(`/${base}?offset=${offset}&limit=${limit}`, {
      params,
    }),
  getAllArchitectureDesignNames: () => Request.get(`/${base}/fetch/all`),
  updateArchitectureDesign: (id, data) =>
    Request.put(`/${base}/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteArchitectureDesign: (id) => Request.delete(`/${base}/${id}`),
  addArchitectureDesignToHomeScreen: (data) =>
    Request.post(`/${base}/change-home-screen-status`, data),
  addPopularArchitectureDesign: (data) =>
    Request.post(`/${base}/add-popular-${base}`, data),
  getArchitectureDesignById: (id) =>
    Request.get(
      `/${base}/single${base
        .split("-")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join("")}?id=${id}`,
    ),
  getSimilarDesign: (id) => Request.get(`/${base}/similar/${id}`),
  addSimilarDesign: (data) => Request.post(`/${base}/similar`, data),
  removeSimilarDesign: (id) => Request.delete(`/${base}/similar/${id}`),
  updateSimilarDesignPosition: (id, position) =>
    Request.put(`/${base}/similar/update-position`, { id, position }),
  getSimilarDesignExpectSelected: (id) => Request.get(`/${base}/expect/${id}`),
  updateArchitectureDesignPosition: (data) =>
    Request.put(`/${base}/update-position`, data),
  updateArchitectureDesignPrimaryImage: (id) =>
    Request.put(`/${base}/primary-image/${id}`),
});

const commercialArchitectureDesignModuleApis = createArchitectureDesignModuleApis(
  "commercial-architecture-design",
);
const corporateArchitectureDesignModuleApis = createArchitectureDesignModuleApis(
  "corporate-architecture-design",
);

export const Apis = {
  login: (data) => Request.post("/user/login", data),
  forgotPassword: (data) =>
    Request.post("/user/send-reset-password-otp", data),
  verifyOtp: (data) => Request.post("/user/verify-otp", data),
  resetPassword: (data) =>
    Request.post("/user/reset-password", data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }),
  getUser: () => Request.get("/user"),
  updatePassword: (data) => Request.post("/user/update-password", data),
  // Category Apis
  addCategory: (data) => Request.post("/category", data),
  getCategories: () => Request.get("/category"),
  getCategoriesWithPagination: (offset = 0, limit = 10, params) =>
    Request.get(`/category?offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  getCategoriesToAddProducts: () =>
    Request.get("/category/admin-category-list"),
  updateCategoryStatus: (id, data) => Request.patch(`/category/status`, data),
  updateCategoryData: (id, data) =>
    Request.put(`/category/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getCategoryProducts: (id) => Request.get(`/product?categoryId=${id}`),
  getCategoryProductsWithPagination: (id, offset = 0, limit = 10, params) =>
    Request.get(`/product?categoryId=${id}&offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  deleteCategory: (id) => Request.delete(`/category/${id}`),
  updateCategoryPosition: (data) =>
    Request.put("/category/update-position", data),
  // Prodcuts Api
  getProducts: () => Request.get("/product"),
  getProductsWithPagination: (offset = 0, limit = 10, params) =>
    Request.get(`/product?offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  getProductNameList: () => Request.get("/product/name-id-list"),
  updateProductStatus: (data) => Request.patch(`/product/status`, data),
  getProductDetails: (id) => Request.get(`/product?id=${id}`),
  deletProduct: (id) => Request.delete(`/product/${id}`),
  addProduct: (data) =>
    Request.post("/product", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  showOnHomeScreen: (data) => Request.post("/product/change-order", data),
  getProductById: (id) => Request.get(`/product/`, { params: { id } }),
  updateProductPosition: (productId, newPosition) =>
    Request.put("/product/update-position", { productId, newPosition }),
  // Users Apis
  getAllUsers: (offset = 0, limit = 9) =>
    Request.get("/user/all", { params: { offset, limit } }),
  searchUsers: (params) => Request.get(`/user/all`, { params: params }),
  updateUSerStatus: (data) => Request.patch(`/user/update`, data),
  // Orders Apis
  getOrders: (params) =>
    Request.get("/orders", {
      params: params,
    }),

  updateOrderStatus: (orderId, body) =>
    Request.put(`/orders/update-status?orderId=${orderId}`, body),
  // Verify Payments
  getPayments: (queryParams) => {
    const params = new URLSearchParams();
    Object.entries(queryParams || {}).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      params.append(key, String(value));
    });
    const queryString = params.toString();
    return Request.get(
      `/orders/payment-screenshots${queryString ? `?${queryString}` : ""}`,
    )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error("Error fetching payments:", error);
        throw error;
      });
  },

  updatePaymentStatus: (id, body) =>
    Request.put(`/orders/${id}/verify-payment`, body),

  // Reviews
  acceptReviews: (body) => Request.put(`/reviews`, body),
  getReviews: (params) => Request.get("/reviews", { params }),
  // Bank Accounts
  getBankAccounts: () => Request.get("/bank/bankAccountDetails"),
  addBankAccount: (data) => Request.post("/bank/bankAccountDetails", data),
  delteBankAccount: (id) => Request.delete(`/bank/bankAccountDetails/${id}`),
  updateBankAccount: (id, data) =>
    Request.put(`/bank/bankAccountDetails/${id}`, data),
  // Pickup Points
  getPickupPoints: (offset = 0, limit = 20) =>
    Request.get("/pickup-points/manage", {
      params: { offset, limit },
    }),
  createPickupPoint: (data) => Request.post("/pickup-points", data),
  updatePickupPoint: (id, data) => Request.put(`/pickup-points/${id}`, data),
  togglePickupPointStatus: (id) =>
    Request.patch(`/pickup-points/toggle-status/${id}`),
  deletePickupPoint: (id) => Request.delete(`/pickup-points/${id}`),
  // Get Utm
  getUtmLinks: () => Request.get("/utm/all"),
  createUtm: (data) => Request.post("/utm/create", data),
  // URL should be in this format: /utm/update?id=123&status=true
  updateUtmStatus: (id, status) =>
    Request.patch(`/utm/update?id=${id}&status=${status}`),
  // Cities
  getCities: (offset = 0, limit = 9) =>
    Request.get("/cities", {
      params: { offset, limit },
    }),
  createCity: (data) => Request.post("/cities", data),
  updateCityStatus: (id, data) => Request.put(`/cities/${id}`, data),
  deleteCity: (id) => Request.delete(`/cities/${id}`),
  // Product Delivery Charges
  getProductsDeliveryCharges: (offset = 0, limit = 9) =>
    Request.get("/delivery-charges/product", {
      params: { offset, limit },
    }),
  addProductDeliveryCharges: (data) =>
    Request.post("/delivery-charges/product", data),
  deleteProductDeliveryCharges: (id) =>
    Request.delete(`/delivery-charges/product/${id}`),
  updateProductDeliveryCharges: (id, data) =>
    Request.put(`/delivery-charges/product/${id}`, data),
  // Terms and Conditions
  getTermsAndConditions: () => Request.get("/tac"),
  addTermsAndConditions: (data) => Request.post("/tac", data),
  updateTermsAndConditions: (id, data) => Request.put(`/tac${id}`, data),
  // Privacy Policy
  getPrivacyPolicy: () => Request.get("/pap/privacy-policy"),
  addPrivacyPolicy: (data) => Request.post("/pap/privacy-policy", data),
  updatePrivacyPolicy: (id, data) =>
    Request.put(`/pap/privacy-policy/${id}`, data),
  // Faq
  getFaq: () => Request.get("/frequently/faqs"),
  addFaq: (data) => Request.post("/frequently/faqs", data),
  updateFaq: (id, data) => Request.put(`/frequently/faqs/${id}`, data),
  // Discounted Products
  getDiscountedProducts: (id) =>
    Request.get(`/product/dicounted-products/${id}`),
  addDiscountedProducts: (data) => {
    return Request.post("/product/addDiscountTiers", data);
  },
  deleteDiscountedProducts: (id, discountTierId) =>
    Request.delete(`/product/remove/${id}/${discountTierId}`),

  // Order Details
  getOrderByOrderId: (orderId) => Request.get(`/orders?orderId=${orderId}`),

  // Dashboard Stats
  getStats: (params) => Request.get("/dashboard/stats", { params }),
  getDashboardDesigns: (params) => Request.get("/dashboard/designs", { params }),
  getDashboardInteriorDesigns: (params) =>
    Request.get("/dashboard/interior-designs", { params }),
  getDashboardShop: (params) => Request.get("/dashboard/shop", { params }),
  getDashboardBlogs: (params) => Request.get("/dashboard/blogs", { params }),
  getDashboardProjects: (params) =>
    Request.get("/dashboard/projects", { params }),
  getDashboardContracts: (params) =>
    Request.get("/dashboard/contracts", { params }),
  getDashboardPricing: (params) => Request.get("/dashboard/pricing", { params }),
  // Pdf
  generatePdf: (data) => Request.post("/quotation/admin", data),
  getAllProducts: () => Request.get("/quotation/products"),
  getVarinatByProductId: (productId) =>
    Request.get(`/quotation/product/${productId}/variants`),
  getColorsByVariantId: (variantId) =>
    Request.get(`/quotation/variant/${variantId}/colors`),
  getProductsForDeliveryCharges: () =>
    Request.get(`/product?offset=0&limit=1000`),
  addStock: (payload) => Request.post("/product/update-stock", payload),
  // Variant Stock Management
  updateVariantStock: (data) =>
    Request.post("/product/update-variant-stock", data),
  updateVariantStockDetails: (data) =>
    Request.put("/product/update-variant-stock-details", data),
  updateMultipleVariantStock: (data) =>
    Request.post("/product/update-multiple-variant-stock", data),
  addCarouselItems: (data) => Request.post("/product/change-order", data),
  getCarouselItems: () => Request.get("/product/carousel-products"),
  updateCarouselItems: (data) => Request.put("product/update-carousel", data),
  addFeaturedProduct: (data) => Request.post("/product/similar-products", data),
  getFeaturedProductsRelations: (id) =>
    Request.get(`/product/product-relation/${id}`),
  deleteLinkedProduct: (id) =>
    Request.delete(`/product/remove-similar-product/${id}`),
  updateSimilarProductPosition: (id, position) =>
    Request.put("/product/update-similar-product-position", { id, position }),
  getUnlinkedProducts: (id) =>
    Request.get(`/product/unlinked-feature-products/${id}`),
  updateProduct: (id, data) =>
    Request.put(`/product/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  addBanner: (data) =>
    Request.post("/banners/add", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  getBanners: () => Request.get("/banners/get"),

  updateBanner: (id, data) =>
    Request.put(`/banners/update/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  deleteBanner: (id) => Request.delete(`/banners/delete/${id}`),
  getPricing: () => Request.get("/pricing"),
  createPricing: (data) => Request.post("/pricing", data),
  updatePricing: (id, data) => Request.put(`/pricing/${id}`, data),
  deletePricing: (id) => Request.delete(`/pricing/${id}`),

  getPremiumPricing: () => Request.get("/premium-pricing"),
  createPremiumPricing: (data) => Request.post("/premium-pricing", data),
  updatePremiumPricing: (id, data) =>
    Request.put(`/premium-pricing/${id}`, data),
  deletePremiumPricing: (id) => Request.delete(`/premium-pricing/${id}`),

  addBrand: (data) =>
    Request.post("/brands", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getBrands: () => Request.get("/brands"),
  updateBrand: (id, data) =>
    Request.put(`/brands/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteBrand: (id) => Request.delete(`/brands/${id}`),

  // Tentative Cost Data
  getTentativeCost: () => Request.get("/tentative-cost"),
  addOrUpdateTentativeCost: (data) => Request.post("/tentative-cost", data),

  // Home Screen Management
  getHomeScreenData: () => Request.get("/home-screen"),
  updateHomeScreenData: (id, data) =>
    Request.put(`/home-screen/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  postHomeScreenData: (data) =>
    Request.post("/home-screen", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteHomeScreenData: (id) => Request.delete(`/home-screen/${id}`),
  getHomeScreenTypes: () => Request.get("/home-screen/types"),
  getHomeScreenSubTypes: (typeId) => Request.get(`/home-screen/sub-types/${typeId}`),
  addHouseDesign: (data) =>
    Request.post("/house-design", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getHouseDesign: (offset = 0, limit = 10, params) =>
    Request.get(`/house-design?offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  getAllHouseDesignNames: () => Request.get(`/house-design/fetch/all`),
  updateHouseDesign: (id, data) =>
    Request.put(`/house-design/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteHouseDesign: (id) => Request.delete(`/house-design/${id}`),
  addHouseDesignToHomeScreen: (data) =>
    Request.post("/house-design/change-home-screen-status", data),
  addPopularHouseDesign: (data) =>
    Request.post("/house-design/add-popular-house-design", data),
  getHouseDesignById: (id) =>
    Request.get(`/house-design/singleHouseDesign?id=${id}`),
  getSimilarDesign: (id) => Request.get(`/house-design/similar/${id}`),
  addSimilarDesign: (data) => Request.post("/house-design/similar", data),
  removeSimilarDesign: (id) => Request.delete(`/house-design/similar/${id}`),
  updateSimilarHouseDesignPosition: (id, position) =>
    Request.put("/house-design/similar/update-position", { id, position }),
  getAllHouseDesign: (id) =>
    Request.get(`/house-designs/${encodeURIComponent(id)}`),
  getSimilarDesignExpectSelected: (id) =>
    Request.get(`/house-design/expect/${id}`),
  updateHouseDesignPosition: (data) =>
    Request.put("/house-design/update-position", data),

  addFrontElevation: (data) =>
    Request.post("/front-elevation", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  getFrontElevation: () => Request.get("/front-elevation"),
  getFrontElevationWithPagination: (offset = 0, limit = 10) =>
    Request.get(`/front-elevation?page=${offset}&limit=${limit}`),
  getFrontElevationById: (id) =>
    Request.get(`/front-elevation/single-front-elevation/${id}`),
  updateFrontElevation: (id, data) =>
    Request.put(`/front-elevation/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  deleteFrontElevation: (id) => Request.delete(`/front-elevation/${id}`),

  addPopularFrontElevation: (data) =>
    Request.post("/front-elevation/add-popular-front-elevation", data),

  getSimilarFrontElevation: (id) =>
    Request.get(`/front-elevation/similar/${id}`),

  addSimilarFrontElevation: (data) =>
    Request.post("/front-elevation/similar", data),

  removeSimilarFrontElevation: (id) =>
    Request.delete(`/front-elevation/similar/${id}`),

  updateSimilarFrontElevationPosition: (id, position) =>
    Request.put("/front-elevation/similar/update-position", { id, position }),

  getAllFrontElevation: (id) =>
    Request.get(
      `/front-elevation/all-front-elevation/${encodeURIComponent(id)}`,
    ),

  getSimilarFrontElevationExpectSelected: (id) =>
    Request.get(`/front-elevation/expect/${id}`),
  getAllBlogCategories: () => Request.get("/blog-categories/all"),
  addCategoryBlog: (data) => Request.post("/blog-categories", data),
  getBlogCategories: (offset = 0, limit = 10, params) =>
    Request.get(`/blog-categories?offset=${offset}&limit=${limit}`, {
      params: params,
    }),
  updateBlogCategory: (id, data) => Request.put(`/blog-categories/${id}`, data),
  deleteBlogCategory: (id) => Request.delete(`/blog-categories/${id}`),
  updateStatus: (id, data) =>
    Request.put(`/blog-categories/${id}/status`, data),
  updateBlogCategoryStatus: (id, status) =>
    Request.patch(`/blog-categories/${id}/status`, { status }),
  getBlogCategoryById: (id) => Request.get(`/blog-categories/${id}`),
  updateBlogCategoryPosition: (data) =>
    Request.put("/blog-categories/update-position", data),
  postBlog: (data) =>
    Request.post("/blog", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateBlog: (id, data) =>
    Request.put(`/blog/update/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  getBlogs: (params) => Request.get("/blog/get-all-blogs", { params }),
  addBlogToHomeScreen: (data) =>
    Request.post("/blog/change-home-screen-status", data),
  getBlogById: (id) => Request.get(`/blog/${id}`),
  addPopularBlog: (data) => Request.post("/blog/add-popular", data),
  addOnHeaderBlog: (data) => Request.post("/blog/add-header", data),
  deleteBlog: (id) => Request.delete(`/blog/${id}`),
  updateBlogPosition: (data) => Request.put("/blog/update-position", data),

  // House Plans
  getBuyPlans: () => Request.get("/buy-plans"),
  getBuyPlansById: (id) => Request.get(`/buy-plans/${id}`),
  addBuyPlan: (data) => Request.post("/buy-plans", data),
  deleteBuyPlan: (id) => Request.delete(`/buy-plans/${id}`),
  updateBuyPlan: (id, data) => Request.put(`/buy-plans/${id}`, data),

  // Purchased House Designs (admin)
  getPurchasedHouseDesigns: (params = {}) =>
    Request.get(`/house-design/admin/purchased-house-designs`, { params }),
  getPurchasedHouseDesignById: (id) =>
    Request.get(`/house-design/admin/purchased-house-designs/${id}`),
  verifyPurchasedHouseDesignPayment: (purchaseId, body) =>
    Request.put(
      `/house-design/admin/purchased-house-designs/${purchaseId}/verify-payment`,
      body,
    ),

  // House Plan Association
  associateBuyPlanToHouseDesing: (body) =>
    Request.post("/buy-plans/buy-options-associtaion", body),
  getAssociardPlan: (houseDesignId) =>
    Request.get(
      `/buy-plans/buy-options-associtaion?house_design_id=${houseDesignId}`,
    ),
  updateHouseDesignPrimaryImage: (id) =>
    Request.put(`/house-design/primary-image/${id}`),
  updateProductPrimaryImage: (id) =>
    Request.put(`/product/primary-image/${id}`),
  getBuyPlanByHouseDesignId: (buyPlanId) =>
    Request.get(`buy-plans/buy-options-associtaion?buy_plan_id=${buyPlanId}`),
  getBuyPlanByHouseDesignIdData: (buyPlanId) =>
    Request.get(`/buy-plans/buy-options-associtaion/${buyPlanId}`),
  getExcludedHousePlans: (buyPlanId) =>
    Request.get(`buy-plans/excluded-houseDesing?buy_plan_id=${buyPlanId}`),
  updateBuyAssociatedPlan: (body) =>
    Request.put("buy-plans/update-buy-options-association", body),
  deleteBuyPlanFromHouseDesign: (id) =>
    Request.delete(`buy-plans/delete-options-association/${id}`),

  // Our Projects
  getOurProjects: (id) => Request.get(`our-projects/`, { params: { id } }),
  getAllProjectCategories: () => Request.get("our-projects/categories"),
  addProject: (data) =>
    Request.post("our-projects/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateProject: (id, data) =>
    Request.put(`our-projects/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteProject: (id) => Request.delete(`our-projects/${id}`),
  getProjectById: (id) => Request.get(`our-projects/`, { params: { id } }),
  addProjectToHomeScreen: (data) =>
    Request.post("/our-projects/change-home-screen-status", data),
  getSimilarProjectExpectAdded: (id) =>
    Request.get(`our-projects/similar-expect-added/`, { params: { id } }),
  postSimilarProject: (data) =>
    Request.post(`our-projects/similar-projects/`, data),
  deleteSimilarProject: (id) =>
    Request.delete(`our-projects/similar-projects/`, { params: { id } }),
  updateSimilarProjectPosition: (id, position) =>
    Request.put("our-projects/similar-projects/update-position", {
      id,
      position,
    }),
  getAddedSimilarProject: (id) =>
    Request.get(`our-projects/similar-projects/`, { params: { id } }),
  getParentProjectCategories: () =>
    Request.get("our-projects/fetch-parent-category"),
  addSubCategory: (data) =>
    Request.post("our-projects/add-sub-category", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateSubCategory: (data) =>
    Request.put("our-projects/update-sub-category", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getSubCategories: (params) =>
    Request.get("our-projects/get-sub-categories", { params }),
  getOnTheBasisOfSubCategory: (id, params) =>
    Request.get(`our-projects/by-sub-category-id/${id}`, { params }),
  toggleProjectStatus: (id) => Request.put(`our-projects/toggle-status/${id}`),
  updateSubCategoryPosition: (id, position) =>
    Request.put("our-projects/update-category-position", { id, position }),
  updateProjectPosition: (data) =>
    Request.put("our-projects/update-position", data),

  // Interior Design Categories
  addInteriorDesignCategory: (data) =>
    Request.post("interior-design-categories", data),
  getInteriorDesignCategories: () => Request.get("interior-design-categories"),
  getInteriorDesignCategoriesWithPagination: (
    offset = 0,
    limit = 10,
    params = {},
  ) => {
    const queryParams = { offset, limit, ...params };
    return Request.get("interior-design-categories", { params: queryParams });
  },
  updateInteriorDesignCategory: (id, data) =>
    Request.put(`interior-design-categories/${id}`, data),
  deleteInteriorDesignCategory: (id) =>
    Request.delete(`interior-design-categories/${id}`),
  toggleInteriorDesignCategoryStatus: (id, status) =>
    Request.patch(`interior-design-categories/toggle-status/${id}`, { status }),
  updateInteriorDesignCategoryPosition: (data) =>
    Request.put("interior-design-categories/update-position", data),
  addInteriorDesignCategoryToHomeScreen: (data) =>
    Request.post("/interior-design-categories/change-home-screen-status", data),

  // Interior Design
  createInteriorDesign: (data) =>
    Request.post("interior-design/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getInteriorDesign: (offset = 0, limit = 10, params = {}) => {
    const queryParams = { offset, limit, ...params };
    return Request.get("interior-design", { params: queryParams });
  },
  getInteriorDesignById: (id) =>
    Request.get(`interior-design/get-single-interior-design/${id}`),
  updateInteriorDesign: (id, data) =>
    Request.put(`interior-design/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteInteriorDesign: (id) => Request.delete(`interior-design/${id}`),
  getAllInteriorDesignCategories: () =>
    Request.get("interior-design-categories/all"),

  // Popular Interior Design APIs
  addPopularInteriorDesign: (data) =>
    Request.post("/interior-design/add-popular-interior-design", data),
  getAllInteriorDesigns: () => Request.get("/interior-design/on-home-screen"),
  getAllInteriorDesignNamesForPopularDesign: () =>
    Request.get("/interior-design/all-names"),
  addInteriorDesignToHomeScreen: (data) =>
    Request.post("/interior-design/change-home-screen-status", data),

  // Similar Interior Design APIs
  getSimilarInteriorDesign: (id) =>
    Request.get(`/interior-design/similar-design/${id}`),
  addSimilarInteriorDesign: (data) =>
    Request.post("/interior-design/similar", data),
  removeSimilarInteriorDesign: (id) =>
    Request.delete(`/interior-design/similar/${id}`),
  updateSimilarInteriorDesignPosition: (id, position) =>
    Request.put("/interior-design/similar/update-position", { id, position }),
  getSimilarInteriorDesignExpectSelected: (id) =>
    Request.get(`/interior-design/expect/${id}`),
  updateInteriorDesignPosition: (data) =>
    Request.put("/interior-design/update-position", data),

  createCommercialInteriorDesign:
    commercialInteriorDesignModuleApis.createInteriorDesign,
  getCommercialInteriorDesign:
    commercialInteriorDesignModuleApis.getInteriorDesign,
  getCommercialInteriorDesignById:
    commercialInteriorDesignModuleApis.getInteriorDesignById,
  updateCommercialInteriorDesign:
    commercialInteriorDesignModuleApis.updateInteriorDesign,
  deleteCommercialInteriorDesign:
    commercialInteriorDesignModuleApis.deleteInteriorDesign,
  addPopularCommercialInteriorDesign:
    commercialInteriorDesignModuleApis.addPopularInteriorDesign,
  getAllCommercialInteriorDesigns:
    commercialInteriorDesignModuleApis.getAllInteriorDesigns,
  getAllCommercialInteriorDesignNamesForPopularDesign:
    commercialInteriorDesignModuleApis.getAllInteriorDesignNamesForPopularDesign,
  addCommercialInteriorDesignToHomeScreen:
    commercialInteriorDesignModuleApis.addInteriorDesignToHomeScreen,
  updateCommercialInteriorDesignPosition:
    commercialInteriorDesignModuleApis.updateInteriorDesignPosition,

  createCorporateInteriorDesign:
    corporateInteriorDesignModuleApis.createInteriorDesign,
  getCorporateInteriorDesign:
    corporateInteriorDesignModuleApis.getInteriorDesign,
  getCorporateInteriorDesignById:
    corporateInteriorDesignModuleApis.getInteriorDesignById,
  updateCorporateInteriorDesign:
    corporateInteriorDesignModuleApis.updateInteriorDesign,
  deleteCorporateInteriorDesign:
    corporateInteriorDesignModuleApis.deleteInteriorDesign,
  addPopularCorporateInteriorDesign:
    corporateInteriorDesignModuleApis.addPopularInteriorDesign,
  getAllCorporateInteriorDesigns:
    corporateInteriorDesignModuleApis.getAllInteriorDesigns,
  getAllCorporateInteriorDesignNamesForPopularDesign:
    corporateInteriorDesignModuleApis.getAllInteriorDesignNamesForPopularDesign,
  addCorporateInteriorDesignToHomeScreen:
    corporateInteriorDesignModuleApis.addInteriorDesignToHomeScreen,
  updateCorporateInteriorDesignPosition:
    corporateInteriorDesignModuleApis.updateInteriorDesignPosition,

  addCommercialArchitectureDesign:
    commercialArchitectureDesignModuleApis.addArchitectureDesign,
  getCommercialArchitectureDesign:
    commercialArchitectureDesignModuleApis.getArchitectureDesign,
  getAllCommercialArchitectureDesignNames:
    commercialArchitectureDesignModuleApis.getAllArchitectureDesignNames,
  updateCommercialArchitectureDesign:
    commercialArchitectureDesignModuleApis.updateArchitectureDesign,
  deleteCommercialArchitectureDesign:
    commercialArchitectureDesignModuleApis.deleteArchitectureDesign,
  addCommercialArchitectureDesignToHomeScreen:
    commercialArchitectureDesignModuleApis.addArchitectureDesignToHomeScreen,
  addPopularCommercialArchitectureDesign:
    commercialArchitectureDesignModuleApis.addPopularArchitectureDesign,
  getCommercialArchitectureDesignById:
    commercialArchitectureDesignModuleApis.getArchitectureDesignById,
  getSimilarCommercialArchitectureDesign:
    commercialArchitectureDesignModuleApis.getSimilarDesign,
  addSimilarCommercialArchitectureDesign:
    commercialArchitectureDesignModuleApis.addSimilarDesign,
  removeSimilarCommercialArchitectureDesign:
    commercialArchitectureDesignModuleApis.removeSimilarDesign,
  updateSimilarCommercialArchitectureDesignPosition:
    commercialArchitectureDesignModuleApis.updateSimilarDesignPosition,
  getSimilarCommercialArchitectureDesignExpectSelected:
    commercialArchitectureDesignModuleApis.getSimilarDesignExpectSelected,
  updateCommercialArchitectureDesignPosition:
    commercialArchitectureDesignModuleApis.updateArchitectureDesignPosition,
  updateCommercialArchitectureDesignPrimaryImage:
    commercialArchitectureDesignModuleApis.updateArchitectureDesignPrimaryImage,

  addCorporateArchitectureDesign:
    corporateArchitectureDesignModuleApis.addArchitectureDesign,
  getCorporateArchitectureDesign:
    corporateArchitectureDesignModuleApis.getArchitectureDesign,
  getAllCorporateArchitectureDesignNames:
    corporateArchitectureDesignModuleApis.getAllArchitectureDesignNames,
  updateCorporateArchitectureDesign:
    corporateArchitectureDesignModuleApis.updateArchitectureDesign,
  deleteCorporateArchitectureDesign:
    corporateArchitectureDesignModuleApis.deleteArchitectureDesign,
  addCorporateArchitectureDesignToHomeScreen:
    corporateArchitectureDesignModuleApis.addArchitectureDesignToHomeScreen,
  addPopularCorporateArchitectureDesign:
    corporateArchitectureDesignModuleApis.addPopularArchitectureDesign,
  getCorporateArchitectureDesignById:
    corporateArchitectureDesignModuleApis.getArchitectureDesignById,
  getSimilarCorporateArchitectureDesign:
    corporateArchitectureDesignModuleApis.getSimilarDesign,
  addSimilarCorporateArchitectureDesign:
    corporateArchitectureDesignModuleApis.addSimilarDesign,
  removeSimilarCorporateArchitectureDesign:
    corporateArchitectureDesignModuleApis.removeSimilarDesign,
  updateSimilarCorporateArchitectureDesignPosition:
    corporateArchitectureDesignModuleApis.updateSimilarDesignPosition,
  getSimilarCorporateArchitectureDesignExpectSelected:
    corporateArchitectureDesignModuleApis.getSimilarDesignExpectSelected,
  updateCorporateArchitectureDesignPosition:
    corporateArchitectureDesignModuleApis.updateArchitectureDesignPosition,
  updateCorporateArchitectureDesignPrimaryImage:
    corporateArchitectureDesignModuleApis.updateArchitectureDesignPrimaryImage,

  // Zone CRUD operations
  getZone: (id) => Request.get(`/zone/${id}`),
  getAllZone: (offset = 0, limit = 10) =>
    Request.get("/zone", {
      params: { offset, limit },
    }),
  getZones: () => Request.get("/zone/all"),
  createZone: (data) => Request.post("/zone", data),
  updateZone: (id, data) => Request.put(`/zone/${id}`, data),
  deleteZone: (id) => Request.delete(`/zone/${id}`),

  // Services Categories (CRUD)
  addServiceCategory: (data) =>
    Request.post("/services-categories", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getServicesCategories: (offset = 0, limit = 10, params) =>
    Request.get(`/services-categories?offset=${offset}&limit=${limit}`, {
      params,
    }),
  // For dropdowns: fetch everything (no offset/limit).
  getServicesCategoriesForSelect: () => Request.get("/services-categories"),
  updateServiceCategory: (id, data) =>
    Request.put(`/services-categories/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteServiceCategory: (id) => Request.delete(`/services-categories/${id}`),
  getServiceCategoryById: (id) => Request.get(`/services-categories/${id}`),

  // InStation Base Rate CRUD operations
  getAllInStation: (offset = 0, limit = 10) =>
    Request.get("/in-station-base-rate", {
      params: { offset, limit },
    }),
  getInStationBaseRate: (id) => Request.get(`/in-station-base-rate/${id}`),
  createInStationBaseRate: (data) =>
    Request.post("/in-station-base-rate", data),
  updateInStationBaseRate: (id, data) =>
    Request.put(`/in-station-base-rate/${id}`, data),
  deleteInStationBaseRate: (id) =>
    Request.delete(`/in-station-base-rate/${id}`),

  // OutStation Base Rate CRUD operations
  getAllOutStationBaseRates: (offset = 0, limit = 10) =>
    Request.get("/out-station-base-rate", {
      params: { offset, limit },
    }),
  getOutStationBaseRate: (id) => Request.get(`/out-station-base-rate/${id}`),
  createOutStationBaseRate: (data) =>
    Request.post("/out-station-base-rate", data),
  updateOutStationBaseRate: (id, data) =>
    Request.put(`/out-station-base-rate/${id}`, data),
  deleteOutStationBaseRate: (id) =>
    Request.delete(`/out-station-base-rate/${id}`),

  // InStation Zone CRUD operations
  getAllInStationZone: (offset = 0, limit = 10) =>
    Request.get("/in-station-zone", {
      params: { offset, limit },
    }),
  getInStationZone: (id) => Request.get(`/in-station-zone/${id}`),
  createInStationZone: (data) => Request.post("/in-station-zone", data),
  updateInStationZone: (id, data) =>
    Request.put(`/in-station-zone/${id}`, data),
  deleteInStationZone: (id) => Request.delete(`/in-station-zone/${id}`),
  getAllInStationZones: () => Request.get("/in-station-zone/all"),

  // Services
  getServices: (offset = 0, limit = 10, params) =>
    Request.get(`/services?offset=${offset}&limit=${limit}`, { params }),
  getServiceById: (id) => Request.get(`/services/${id}`),
  addService: (data) =>
    Request.post("/services", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateService: (id, data) =>
    Request.put(`/services/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteService: (id) => Request.delete(`/services/${id}`),

  // Contracts
  postContract: (data) =>
    Request.post("/contracts", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getContracts: (offset = 0, limit = 10, params) =>
    Request.get(`/contracts?offset=${offset}&limit=${limit}`, { params }),
  getContractById: (id) => Request.get(`/contracts/${id}`),
  updateContract: (id, data) => Request.put(`/contracts/${id}`, data),
  deleteContract: (id) => Request.delete(`/contracts/${id}`),
  getUserContracts: (params) => Request.get(`/user-contracts`, { params }),

  // Design Contracts
  postDesignContract: (data) =>
    Request.post("/design-contracts", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getDesignContracts: (offset = 0, limit = 10, params) =>
    Request.get(`/design-contracts?offset=${offset}&limit=${limit}`, {
      params,
    }),
  getDesignContractById: (id) => Request.get(`/design-contracts/${id}`),
  updateDesignContract: (id, data) => {
    const isFormData =
      typeof FormData !== "undefined" && data instanceof FormData;
    return Request.put(`/design-contracts/${id}`, data, isFormData
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : undefined);
  },
  deleteDesignContract: (id) => Request.delete(`/design-contracts/${id}`),
  getUserDesignContracts: (params) =>
    Request.get(`/user-design-contracts`, { params }),

  // Construction Calculator
  getConstructionCalculators: (offset = 0, limit = 10) =>
    Request.get(`/construction-calculator?offset=${offset}&limit=${limit}`),
  addConstructionCalculator: (data) =>
    Request.post("/construction-calculator", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateConstructionCalculator: (id, data) =>
    Request.put(`/construction-calculator/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteConstructionCalculator: (id) =>
    Request.delete(`/construction-calculator/${id}`),

  // Similar Items (Generic)
  getAdminSimilarItemsList: (params) =>
    Request.get("/admin/similar-items/list", { params }),
  getSimilarItems: (params) => Request.get("/similar-items", { params }),
  addSimilarItems: (data) => Request.post("/similar-items", data),
  removeSimilarItem: (data) => Request.delete("/similar-items", { data }),
  updateSimilarItemPosition: (data) =>
    Request.put("/similar-items/update-position", data),

  // SEO Management
  getSeoModules: () => Request.get("/admin/seo/modules"),
  getSeoEntities: (params) => Request.get("/admin/seo/entities", { params }),
  getSeoList: (params) => Request.get("/admin/seo", { params }),
  getSeoById: (id) => Request.get(`/admin/seo/${id}`),
  createSeo: (data) =>
    Request.post("/admin/seo", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateSeo: (id, data) =>
    Request.put(`/admin/seo/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteSeo: (id) => Request.delete(`/admin/seo/${id}`),

  // Translations (Urdu bulk generate)
  getTranslationModules: () => Request.get("/admin/translations/modules"),
  getTranslationStats: () => Request.get("/admin/translations/stats"),
  getTranslationJobs: (params) =>
    Request.get("/admin/translations/jobs", { params }),
  getTranslationJob: (id) => Request.get(`/admin/translations/jobs/${id}`),
  generateTranslations: (data) =>
    Request.post("/admin/translations/generate", data),
  retryTranslationJob: (id) =>
    Request.post(`/admin/translations/jobs/${id}/retry`),
  stopTranslationJob: (id) =>
    Request.post(`/admin/translations/jobs/${id}/stop`),
  deleteTranslationJob: (id) =>
    Request.delete(`/admin/translations/jobs/${id}`),

  // Static Pages SEO
  getStaticPages: (params) => Request.get("/admin/static-pages", { params }),
  getStaticPageUrls: () => Request.get("/admin/static-pages/urls"),
  getStaticPageAvailableUrls: () =>
    Request.get("/admin/static-pages/available-urls"),
  getStaticPageById: (id) => Request.get(`/admin/static-pages/${id}`),
  createStaticPage: (data) =>
    Request.post("/admin/static-pages", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  updateStaticPage: (id, data) =>
    Request.put(`/admin/static-pages/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  // Contract Categories
  addContractCategory: (data) =>
    Request.post("/contract-category", data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  getContractCategories: (offset = 0, limit = 10, params) =>
    Request.get(`/contract-category?offset=${offset}&limit=${limit}`, {
      params,
    }),
  getContractCategoryById: (id) => Request.get(`/contract-category/${id}`),
  updateContractCategory: (id, data) =>
    Request.put(`/contract-category/${id}`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  deleteContractCategory: (id) => Request.delete(`/contract-category/${id}`),

  // Roles and Permissions
  getRoles: (offset = 0, limit = 10, params) =>
    Request.get(`/roles?offset=${offset}&limit=${limit}`, { params }),
  getRoleById: (id) => Request.get(`/roles/${id}`),
  createRole: (data) => Request.post("/roles", data),
  updateRole: (id, data) => Request.put(`/roles/${id}`, data),
  toggleRoleStatus: (id) => Request.patch(`/roles/${id}/toggle-status`),
  deleteRole: (id) => Request.delete(`/roles/${id}`),
  getPermissions: (offset = 0, limit = 50, params) =>
    Request.get(`/permissions?offset=${offset}&limit=${limit}`, { params }),
  togglePermissionStatus: (id) =>
    Request.patch(`/permissions/${id}/toggle-status`),

  // Admin-created Users
  getAdminUsers: (offset = 0, limit = 10, params) =>
    Request.get(`/user/admin-users?offset=${offset}&limit=${limit}`, {
      params,
    }),
  createAdminUser: (data) => Request.post("/user/admin-users", data),
  getAdminUserById: (id) => Request.get(`/user/admin-users/${id}`),
  updateAdminUser: (id, data) => Request.put(`/user/admin-users/${id}`, data),
  toggleAdminUserStatus: (id) =>
    Request.patch(`/user/admin-users/${id}/toggle-status`),
  deleteAdminUser: (id) => Request.delete(`/user/admin-users/${id}`),
};
